import { TaxReturnRouting } from './TaxReturnRouting';

export const TaxReturnModule = () => {
  return <TaxReturnRouting />;
};
